document.addEventListener('DOMContentLoaded', function () {
    $('[data-stock-ticker]').each(function () {
        var $target = $(this);
        var accessKey = $target.data('ticker-key');

        var sharePerformanceData = null,
            tickerData = null;    

        var urlTicker = 'https://publish.ne.cision.com/papi/Ticker/{{accessKey}}';

        $.ajax({
            url: urlTicker.replace('{{accessKey}}', accessKey),
            type: "GET",
            dataType: "json"
        })
            .done(function (dataObj) {
                tickerData = dataObj;
                if (sharePerformanceData) {
                    var viewModel = buildViewModel(tickerData, sharePerformanceData);
                    renderTicker(viewModel);
                }
            })
            .fail(function () {
                //console.log('Could not retrieve ticker data');
            });

        var urlPerformance = 'https://publish.ne.cision.com/papi/Ticker/{{accessKey}}/Performance';

        $.ajax({
            url: urlPerformance.replace('{{accessKey}}', accessKey),
            type: 'GET',
            dataType: 'json'
        })
            .done(function (dataObj) {
                sharePerformanceData = dataObj;
                if (tickerData) {
                    var viewModel = buildViewModel(tickerData, sharePerformanceData);
                    renderTicker(viewModel);
                }
            });

        function renderTicker(viewModel) {
            var template = $('[data-stock-ticker-template]').html();
            var renderedElement = Mustache.render(template, viewModel);
            $target.html(renderedElement);
        }

        function buildViewModel(tickerData, sharePerformanceData) {
            var viewModel = {
                tickers: []
            };

            var sortedTickerData = tickerData.Instruments;

            for (var instrumentIx = 0; instrumentIx < sortedTickerData.length; instrumentIx++) {
                var instrument = sortedTickerData[instrumentIx],
                    lastDate = "2010-02-01T00:00:00.000000Z",
                    ticker;

                for (var i = 0; i < instrument.Quotes.length; i++) {
                    var quote = instrument.Quotes[0];
                    if (quote.QuoteTime >= lastDate) {
                        ticker = quote;
                    }
                    lastDate = quote.QuoteTime;
                }

                var model = $.extend({}, ticker);

                model.TickerName = instrument.TickerName;
                model.TickerSymbol = instrument.TickerSymbol;
                model.TradeCurrency = instrument.TradeCurrency;

                if (model.DeltaPercentage) {
                    model.DeltaPercentage = model.DeltaPercentage * 100;
                    model.DeltaPercentage = model.DeltaPercentage.toFixed(2);
                    //console.log(model);
                }

                model.Time = new moment(model.QuoteTime).format('HH:mm');
                model.Date = new moment(model.QuoteTime).format('DD MMM YYYY');

                var p = sharePerformanceData.Instruments[instrumentIx],
                    useKiloFormat = false, //om tusen
                    useMegaFormat = true, //om miljon
                    currency = 'NOK',
                    isPrefixedCurrency = false, //före el efter
                    kiloPrefix = " k", //prefix, sätts av user
                    megaPrefix = " M"; //prefix, sätts av user

                var lastPrice = p.LastPrice || p.ClosePrice1D || -1;
                var numberOfShares = p.NumberOfShares || -1;

                var marketCap = numberOfShares * lastPrice;

                model.mcapTotalRaw = Math.round(marketCap);
                model.mcapTotalKilo = Math.round(marketCap / 1000);
                model.mcapTotalMega = Math.round(marketCap / 1000000);

                if (useKiloFormat) {
                    model.mcapTotal = model.mcapTotalKilo + kiloPrefix;
                } else if (useMegaFormat) {
                    model.mcapTotal = model.mcapTotalMega + megaPrefix;
                } else {
                    model.mcapTotal = model.mcapTotalRaw + megaPrefix;
                }

                if (isPrefixedCurrency) {
                    model.mcapTotal = currency + model.mcapTotal;
                } else {
                    model.mcapTotal = model.mcapTotal + currency;
                }

                // Instead of returning a NaN, turn this into an empty string if needed
                model.mcapTotal = model.mcapTotal || '';

                if (model.Delta > 0) {
                    model.ChangeType = 'positive-change';
                } else if (model.Delta < 0) {
                    model.ChangeType = 'negative-change';
                } else {
                    model.ChangeType = 'no-change';
                }

                model.Price = model.Price.toFixed(2);
                model.AskPrice = model.AskPrice.toFixed(2);
                model.BidPrice = model.BidPrice.toFixed(2);
                model.HighPrice = model.HighPrice.toFixed(2);
                model.LowPrice = model.LowPrice.toFixed(2);

                viewModel.tickers.push(model);
            }

            return viewModel;
        }
    });
});